// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"dd930ac6","522":"dd930ac6","582":"dd930ac6","818":"dd930ac6"}[chunkId] + ".chunk.css";
};